// extracted by mini-css-extract-plugin
export default {"container":"L1-z","list":"M1-z"};